import { render, staticRenderFns } from "./SelectableBadges.vue?vue&type=template&id=41318c59&"
import script from "./SelectableBadges.vue?vue&type=script&lang=ts&"
export * from "./SelectableBadges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports